// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.DeviceConfiguration in deviceConfig/deviceConfiguration.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.FieldEncoding
import com.squareup.wire.Message
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.ProtoReader
import com.squareup.wire.ProtoWriter
import com.squareup.wire.ReverseProtoWriter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireField
import com.squareup.wire.`internal`.JvmField
import com.squareup.wire.`internal`.sanitize
import kotlin.Any
import kotlin.AssertionError
import kotlin.Boolean
import kotlin.Deprecated
import kotlin.DeprecationLevel
import kotlin.Int
import kotlin.Long
import kotlin.Nothing
import kotlin.String
import kotlin.Suppress
import okio.ByteString

/**
 * Device configuration. Represents device configuration.
 *
 * @property device Device type e.g. volt
 * @property model Device model e.g. s1
 * @property serial_number Device serial number
 * @property software_version Device software version
 * @property ocr_version OCR version
 * @property local_ip_address Local IP address
 * @property connection_key IoT backend service connection key
 * @property password Device password
 */
public class DeviceConfiguration(
  @field:WireField(
    tag = 1,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 0,
  )
  public val device: String = "",
  @field:WireField(
    tag = 2,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 1,
  )
  public val model: String = "",
  @field:WireField(
    tag = 3,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "serialNumber",
    schemaIndex = 2,
  )
  public val serial_number: String = "",
  @field:WireField(
    tag = 4,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "softwareVersion",
    schemaIndex = 3,
  )
  public val software_version: String = "",
  @field:WireField(
    tag = 5,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "ocrVersion",
    schemaIndex = 4,
  )
  public val ocr_version: String = "",
  @field:WireField(
    tag = 6,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "localIpAddress",
    schemaIndex = 5,
  )
  public val local_ip_address: String = "",
  @field:WireField(
    tag = 7,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "connectionKey",
    schemaIndex = 6,
  )
  public val connection_key: String = "",
  @field:WireField(
    tag = 8,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 7,
  )
  public val password: String = "",
  @field:WireField(
    tag = 9,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "macAddress",
    schemaIndex = 8,
  )
  public val mac_address: String = "",
  unknownFields: ByteString = ByteString.EMPTY,
) : Message<DeviceConfiguration, Nothing>(ADAPTER, unknownFields) {
  @Deprecated(
    message = "Shouldn't be used in Kotlin",
    level = DeprecationLevel.HIDDEN,
  )
  override fun newBuilder(): Nothing = throw AssertionError("Builders are deprecated and only available in a javaInterop build; see https://square.github.io/wire/wire_compiler/#kotlin")

  override fun equals(other: Any?): Boolean {
    if (other === this) return true
    if (other !is DeviceConfiguration) return false
    if (unknownFields != other.unknownFields) return false
    if (device != other.device) return false
    if (model != other.model) return false
    if (serial_number != other.serial_number) return false
    if (software_version != other.software_version) return false
    if (ocr_version != other.ocr_version) return false
    if (local_ip_address != other.local_ip_address) return false
    if (connection_key != other.connection_key) return false
    if (password != other.password) return false
    if (mac_address != other.mac_address) return false
    return true
  }

  override fun hashCode(): Int {
    var result = super.hashCode
    if (result == 0) {
      result = unknownFields.hashCode()
      result = result * 37 + device.hashCode()
      result = result * 37 + model.hashCode()
      result = result * 37 + serial_number.hashCode()
      result = result * 37 + software_version.hashCode()
      result = result * 37 + ocr_version.hashCode()
      result = result * 37 + local_ip_address.hashCode()
      result = result * 37 + connection_key.hashCode()
      result = result * 37 + password.hashCode()
      result = result * 37 + mac_address.hashCode()
      super.hashCode = result
    }
    return result
  }

  override fun toString(): String {
    val result = mutableListOf<String>()
    result += """device=${sanitize(device)}"""
    result += """model=${sanitize(model)}"""
    result += """serial_number=${sanitize(serial_number)}"""
    result += """software_version=${sanitize(software_version)}"""
    result += """ocr_version=${sanitize(ocr_version)}"""
    result += """local_ip_address=${sanitize(local_ip_address)}"""
    result += """connection_key=${sanitize(connection_key)}"""
    result += """password=${sanitize(password)}"""
    result += """mac_address=${sanitize(mac_address)}"""
    return result.joinToString(prefix = "DeviceConfiguration{", separator = ", ", postfix = "}")
  }

  public fun copy(
    device: String = this.device,
    model: String = this.model,
    serial_number: String = this.serial_number,
    software_version: String = this.software_version,
    ocr_version: String = this.ocr_version,
    local_ip_address: String = this.local_ip_address,
    connection_key: String = this.connection_key,
    password: String = this.password,
    mac_address: String = this.mac_address,
    unknownFields: ByteString = this.unknownFields,
  ): DeviceConfiguration = DeviceConfiguration(device, model, serial_number, software_version, ocr_version, local_ip_address, connection_key, password, mac_address, unknownFields)

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<DeviceConfiguration> =
        object : ProtoAdapter<DeviceConfiguration>(
      FieldEncoding.LENGTH_DELIMITED, 
      DeviceConfiguration::class, 
      "type.googleapis.com/vreo.volt.protocol.DeviceConfiguration", 
      PROTO_3, 
      null, 
      "deviceConfig/deviceConfiguration.proto"
    ) {
      override fun encodedSize(`value`: DeviceConfiguration): Int {
        var size = value.unknownFields.size
        if (value.device != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(1, value.device)
        }
        if (value.model != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(2, value.model)
        }
        if (value.serial_number != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(3, value.serial_number)
        }
        if (value.software_version != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(4, value.software_version)
        }
        if (value.ocr_version != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(5, value.ocr_version)
        }
        if (value.local_ip_address != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(6, value.local_ip_address)
        }
        if (value.connection_key != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(7, value.connection_key)
        }
        if (value.password != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(8, value.password)
        }
        if (value.mac_address != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(9, value.mac_address)
        }
        return size
      }

      override fun encode(writer: ProtoWriter, `value`: DeviceConfiguration) {
        if (value.device != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 1, value.device)
        }
        if (value.model != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 2, value.model)
        }
        if (value.serial_number != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 3, value.serial_number)
        }
        if (value.software_version != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 4, value.software_version)
        }
        if (value.ocr_version != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 5, value.ocr_version)
        }
        if (value.local_ip_address != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 6, value.local_ip_address)
        }
        if (value.connection_key != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 7, value.connection_key)
        }
        if (value.password != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 8, value.password)
        }
        if (value.mac_address != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 9, value.mac_address)
        }
        writer.writeBytes(value.unknownFields)
      }

      override fun encode(writer: ReverseProtoWriter, `value`: DeviceConfiguration) {
        writer.writeBytes(value.unknownFields)
        if (value.mac_address != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 9, value.mac_address)
        }
        if (value.password != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 8, value.password)
        }
        if (value.connection_key != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 7, value.connection_key)
        }
        if (value.local_ip_address != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 6, value.local_ip_address)
        }
        if (value.ocr_version != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 5, value.ocr_version)
        }
        if (value.software_version != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 4, value.software_version)
        }
        if (value.serial_number != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 3, value.serial_number)
        }
        if (value.model != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 2, value.model)
        }
        if (value.device != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 1, value.device)
        }
      }

      override fun decode(reader: ProtoReader): DeviceConfiguration {
        var device: String = ""
        var model: String = ""
        var serial_number: String = ""
        var software_version: String = ""
        var ocr_version: String = ""
        var local_ip_address: String = ""
        var connection_key: String = ""
        var password: String = ""
        var mac_address: String = ""
        val unknownFields = reader.forEachTag { tag ->
          when (tag) {
            1 -> device = ProtoAdapter.STRING.decode(reader)
            2 -> model = ProtoAdapter.STRING.decode(reader)
            3 -> serial_number = ProtoAdapter.STRING.decode(reader)
            4 -> software_version = ProtoAdapter.STRING.decode(reader)
            5 -> ocr_version = ProtoAdapter.STRING.decode(reader)
            6 -> local_ip_address = ProtoAdapter.STRING.decode(reader)
            7 -> connection_key = ProtoAdapter.STRING.decode(reader)
            8 -> password = ProtoAdapter.STRING.decode(reader)
            9 -> mac_address = ProtoAdapter.STRING.decode(reader)
            else -> reader.readUnknownField(tag)
          }
        }
        return DeviceConfiguration(
          device = device,
          model = model,
          serial_number = serial_number,
          software_version = software_version,
          ocr_version = ocr_version,
          local_ip_address = local_ip_address,
          connection_key = connection_key,
          password = password,
          mac_address = mac_address,
          unknownFields = unknownFields
        )
      }

      override fun redact(`value`: DeviceConfiguration): DeviceConfiguration = value.copy(
        unknownFields = ByteString.EMPTY
      )
    }

    private const val serialVersionUID: Long = 0L
  }
}
